import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
var _excluded = ["dropup", "alignRight", "onChange", "className", "mandatory", "dateValidation"];
import React, { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// This workaround fixes the react minified #130 error for using external commonjs libs
// see https://github.com/vitejs/vite/issues/2139
import RDT from 'react-datetime';
var Datetime = RDT["default"] ? RDT["default"] : RDT;
var isValidDate = function isValidDate(date) {
  return _typeof(date) === 'object';
};
var DatePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var dropup = props.dropup,
    alignRight = props.alignRight,
    onChange = props.onChange,
    className = props.className,
    mandatory = props.mandatory,
    dateValidation = props.dateValidation,
    remainingProp = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasError = _useState2[0],
    setHasError = _useState2[1];
  var validateDate = function validateDate(dateToValidate) {
    return dateValidation ? dateValidation(dateToValidate) : isValidDate(dateToValidate);
  };
  var handleChange = function handleChange(date) {
    var isValid = mandatory ? validateDate(date) : true;
    setHasError(!isValid);
    onChange(date, isValid);
  };
  var classes = classNames('DatePicker', 'form-group', hasError && 'has-error', dropup && 'dropup', alignRight && 'align-right', className && className);

  // TODO: add support for setting ref to the input. Maybe add a "inputRef" prop to react-datetime
  return /*#__PURE__*/React.createElement(Datetime, _extends({
    ref: ref
  }, remainingProp, {
    onChange: handleChange,
    className: classes
  }));
});
DatePicker.defaultProps = {
  closeOnSelect: true,
  dropup: false,
  locale: 'en-GB',
  onChange: function onChange() {},
  clearableInput: false,
  minWidth: 0,
  mandatory: true
};
DatePicker.propTypes = {
  className: PropTypes.string,
  closeOnSelect: PropTypes.bool,
  clearableInput: PropTypes.bool,
  initialValue: PropTypes.object,
  locale: PropTypes.string,
  onChange: PropTypes.func,
  dropup: PropTypes.bool,
  minWidth: PropTypes.number,
  alignRight: PropTypes.bool,
  mandatory: PropTypes.bool,
  dateValidation: PropTypes.func
};
export default DatePicker;